export default __webpack_public_path__ + "media/img_03/600@2x-b04727b5.jpg";